import React, { Component, } from 'react';
import { string, shape, arrayOf, any, } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Widget from '../../../../legacy-tv-ui/Widget';
import Table from '../../../../legacy-tv-ui/Table';
import Td from '../../../../legacy-tv-ui/Td';
import Tr from '../../../../legacy-tv-ui/Tr';
import Th from '../../../../legacy-tv-ui/Th';
import TextSpan from '../TextSpan';
import Footnote from '../../../../components/Footnote';

export class DescriptionTable extends Component {
  static propTypes = {
    data: arrayOf(shape({
      name: string.isRequired,
      description: arrayOf(any),
      adjustment: arrayOf(any),
    })),
    footnote: string,
  }
  static defaultProps = {
    footnote: null,
    data: [],
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Grid
        item
        xs={12}
        style={{
          padding: 20,
        }}
      >
        <Widget
          title="調整說明"
        >
          <Table style={{ width: '100%', }}>
            <thead>
              <Tr>
                <Th />
                <Th>市場類別</Th>
                <Th style={{ width: 600, }}>調整情形</Th>
                <Th>說明</Th>
              </Tr>
            </thead>
            <tbody>
              {
                this.props.data.map((datum, idx) => (
                  <Tr key={datum.name}>
                    <Td
                      style={{ textAlign: 'center', width: 10, }}
                    >
                      {idx + 1}
                    </Td>
                    <Td
                      style={{ textAlign: 'center', }}
                    >
                      {datum.name}
                    </Td>
                    <Td>
                      {
                        datum.adjustment.map((sentence, idx) => (
                          /* eslint-disable */
                          <p key={idx}>
                            {
                              sentence.map((textSpan, idx) => (
                                <TextSpan
                                  key={idx}
                                  /* eslint-enable */
                                  text={textSpan}
                                />
                              ))
                            }
                          </p>
                        ))
                      }
                    </Td>
                    <Td>
                      {
                        datum.description.map((sentence, idx) => (
                          /* eslint-disable */
                          <p key={idx}>
                            {
                              sentence.map((textSpan, idx) => (
                                <TextSpan
                                  key={idx}
                                  /* eslint-enable */
                                  text={textSpan}
                                />
                              ))
                            }
                          </p>
                        ))
                      }
                    </Td>
                  </Tr>
                ))
              }
            </tbody>
          </Table>
          {
            this.props.footnote &&
            <Footnote>{this.props.footnote}</Footnote>
          }
        </Widget>
      </Grid>
    );
  }
}

export default DescriptionTable;



// WEBPACK FOOTER //
// ./src/scenes/Adjustment/components/DescriptionTable/index.js